import { type FC, type PropsWithChildren } from 'react';

import clipboardIconSrc from './assets/clipboard.svg';

export const ClipboardIconImg: FC<PropsWithChildren> = () => (
  <img src={clipboardIconSrc} alt="An illustrated clipboard with three checklist items on it" />
);
